import { render, staticRenderFns } from "./ApproveConfirmation.vue?vue&type=template&id=10566197&"
import script from "./ApproveConfirmation.vue?vue&type=script&lang=js&"
export * from "./ApproveConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports